import { render, staticRenderFns } from "./TariffRate.vue?vue&type=template&id=99ad7710&scoped=true&"
import script from "./TariffRate.vue?vue&type=script&lang=js&"
export * from "./TariffRate.vue?vue&type=script&lang=js&"
import style0 from "./TariffRate.vue?vue&type=style&index=0&id=99ad7710&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99ad7710",
  null
  
)

export default component.exports